import { render } from "./audioBridge.vue?vue&type=template&id=16da264a"
import script from "./audioBridge.vue?vue&type=script&lang=js"
export * from "./audioBridge.vue?vue&type=script&lang=js"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__